<template>
  <div v-if="allPendingConsults.length > 0" class="alert alert-warning">
    <h2>Pending Consults</h2>
    <p></p>

    <table class="table">
      <thead>
        <tr>
          <th>Name/Company</th>
          <th>Code</th>
          <th>State</th>
          <th>Consult Type</th>
          <th>Continue Consult</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="!hide_winter_consults">
          <pending-consult-row v-for="consult in winterConsults"
                               :consult="consult"
                               :consult-type="'winter_consult'"
                               @consult-changed="refreshConsults"
                               :key="`winter_consult-${consult.client}`">
          </pending-consult-row>
        </template>
        <template v-if="!hide_spring_consults">
          <pending-consult-row v-for="consult in springConsults"
                               :consult="consult"
                               :consult-type="'spring_consult'"
                               @consult-changed="refreshConsults"
                               :key="`spring_consult-${consult.client}`">
          </pending-consult-row>
        </template>
        <template v-if="!hide_dry_cow_consults">
          <pending-consult-row v-for="consult in dryCowConsults"
                               :consult="consult"
                               :consult-type="'dry_cow_consult'"
                               @consult-changed="refreshConsults"
                               :key="`dry_cow_consult-${consult.client}`">
          </pending-consult-row>
        </template>
        <template v-if="!hide_general_farm_consults">
          <pending-consult-row v-for="consult in generalFarmConsults"
                               :consult="consult"
                               :consult-type="'general_farm_consult'"
                               @consult-changed="refreshConsults"
                               :key="`general_farm_consult-${consult.client}`">
          </pending-consult-row>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import { indexedDB } from '../_helpers';
import PendingConsultRow from './PendingConsultRow.vue';

export default {
  components: {
    PendingConsultRow,
  },
  data() {
    return {
      hide_winter_consults: false,
      hide_spring_consults: false,
      hide_dry_cow_consults: false,
      hide_general_farm_consults: false,
      pendingConsults: {
        'winter_consults': [],
        'spring_consults': [],
        'dry_cow_consults': [],
        'general_farm_consults': []
      },
    }
  },
  props: [
    'filterByClient',
    'hideWinterConsults',
    'hideSpringConsults',
    'hideDryCowConsults',
    'hideGeneralFarmConsults',
  ],
  created() {
    indexedDB.keys().then(keys => {
      if (keys.includes('errors'))
      {
        indexedDB.delete('errors', 'winter-consult').catch(() => {})
      }
    })
  },
  mounted()
  {
    this.refreshConsults()
  },
  computed: {
    winterConsults: function ()
    {
      let consults = this.pendingConsults['winter_consults']
      consults = consults.filter(consult => consult.hasOwnProperty('models'))
      if ( this.filterByClient )
      {
        consults = consults.filter(consult => Number(consult.client) == Number(this.filterByClient))
      }
      return consults
    },
    springConsults: function ()
    {
      let consults = this.pendingConsults['spring_consults']
      if ( this.filterByClient )
      {
        consults = consults.filter(consult => Number(consult.client) == Number(this.filterByClient))
      }
      return consults
    },
    dryCowConsults: function ()
    {
      let consults = this.pendingConsults['dry_cow_consults']
      if ( this.filterByClient )
      {
        consults = consults.filter(consult => Number(consult.client) == Number(this.filterByClient))
      }
      return consults
    },
    generalFarmConsults: function ()
    {
      let consults = this.pendingConsults['general_farm_consults']
      consults = consults.filter(consult => consult.hasOwnProperty('models'))
      if ( this.filterByClient )
      {
        consults = consults.filter(consult => Number(consult.client) == Number(this.filterByClient))
      }
      return consults
    },
    allPendingConsults: function ()
    {
      let allConsults = this.pendingConsults['winter_consults']
        .concat(this.pendingConsults['spring_consults'])
        .concat(this.pendingConsults['dry_cow_consults'])
        .concat(this.pendingConsults['general_farm_consults'])
      if (this.filterByClient)
      {
        allConsults = allConsults.filter(c => Number(c.client) == Number(this.filterByClient))
      }
      return allConsults.filter(consult => {
        if (typeof consult.models !== 'object' || consult.models === null) {
          return false
        } else {
          return ((consult.models || {}).Misc || {}).consult_state == 'initial'
        }
      })
    },
  },
  methods: {
    refreshConsults: function ()
    {
      let consultTypes = [
        'winter-consult',
        'spring-consult',
        'dry-cow-consult',
        'general-farm-consult',
      ]
      for (let ctype of consultTypes) {
      indexedDB.getAll(ctype).then(
        consults => {
          let goodConsults = []
          for (let consult of consults) {
            if (typeof consult.models === 'object' && Object.keys(consult.models).length > 0) {
              goodConsults.push(consult)
            } else {
              indexedDB.delete(consult.client, ctype)
            }
          }
          this.pendingConsults[ctype.replaceAll('-', '_') + 's'] = goodConsults
        })
      }
    },
    getConsultState: function(consult) {
      if (consult.models.Misc) {
        if (consult.models.Misc.consult_state == 'finished') {
          return 'Completed'
        } else {
          return 'Initial'
        }
      }
    },
    getClientId: function(clientCode) {
      let client = this.clients.filter(c => c.client_code == clientCode)

      if (client.length > 0) {
        return client[0].id
      }
    },
  }
};
</script>
